import { convertDistance, getDistance } from 'geolib';

// ─────────────────────────────────────────────────────────────────────────────

export function getLocationDistanceInMiles(
  currentPosition: PositionCoordinates,
  targetPosition: PositionCoordinates,
) {
  const distanceInMeters = getDistance(currentPosition, targetPosition);

  return convertDistance(distanceInMeters, 'mi');
}

export function checkIfLocationTooFar(params: CheckIfLocationTooFarParams) {
  const { currentPosition, targetPosition, thresholdInMiles } = params;

  if (thresholdInMiles <= 0) return false;

  return getLocationDistanceInMiles(currentPosition, targetPosition) > thresholdInMiles;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type CheckIfLocationTooFarParams = {
  currentPosition: PositionCoordinates;
  targetPosition: PositionCoordinates;
  thresholdInMiles: number;
};

type PositionCoordinates = {
  latitude: number;
  longitude: number;
};
